export const SMARTY_VAT = 'GB 569 9532 77'

export const getSmartyVAT = () => {
  return SMARTY_VAT
}
